import { MutableRefObject, useRef } from 'react'

export function useLazyRef<T>(initialValFn: () => T) {
  const ref = useRef<T | null>(null)
  if (ref.current === null) {
    ref.current = initialValFn()
  }
  return ref as MutableRefObject<T>
}
